import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { BulletinDescriptor } from './model/bulletin';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class BulletinService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'BulletinManagement',
      authService,
      config.BMSConfig
    );

  }

  public create(bulletinEntity: BulletinDescriptor): Promise<string> {
    return super.post<string>(
      new BulletinDescriptor({
        id: undefined,
        href: undefined,
        name: bulletinEntity.name,
        organizationId: bulletinEntity.organizationId,
        formId: bulletinEntity.formId,
        labelId: bulletinEntity.labelId,
        periodStart: bulletinEntity.periodStart,
        bulletinState: bulletinEntity.bulletinState,
        createdBy: bulletinEntity.createdBy,
        createdOn: bulletinEntity.createdOn,
        assignedTo: bulletinEntity.assignedTo,
        responsible: bulletinEntity.responsible,
        modified: bulletinEntity.modified,
        deleted: bulletinEntity.deleted
      }));
  }

  public getBulletins(view?: View): Promise<List<BulletinDescriptor>> {
    return super.get<List<BulletinDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, role: BulletinDescriptor): Promise<BulletinDescriptor> {
    return super.put<BulletinDescriptor>(id, role);
  }

  public getById(id: string): Promise<BulletinDescriptor> {
    return super.get<BulletinDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/bulletin/bulletin.service.ts